// extracted by mini-css-extract-plugin
export default {"LoadingIndicator":"LoadingIndicator_LoadingIndicator__5cCor"};